class Animate {
    constructor() {
        const animatedElements = document.querySelectorAll('.--animate');
        
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(({ isIntersecting, target: el }) => {
                if (isIntersecting) {
                    const delay = parseInt(el.className.match(/--animate(?:-+delay-)(\d+)(?:ms)?/)?.[1] || '0', 10);
                    delay && (el.style.animationDelay = `${delay}ms`); 
                    el.classList.add('animate--active');
                } else {
                    el.classList.remove('animate--active');
                }
            });
        }, { threshold: 0.1 });
        
        animatedElements.forEach(el => observer.observe(el));
    }
}

export { Animate as default }